<template>
  <div class="fondo-polaroid">
    <div class="overlay"></div>

    <!-- MARCO -->
    <div class="marco-polaroid">
      <img :src="currentImage" class="foto-polaroid" alt="imagen actual" />
    </div>

    <!-- TEXTO DE INVITACIÓN / BÍBLICO -->
    <div ref="textoRef" class="contenedor-texto">
      <p class="texto-invitacion">
        "Donde tú vayas, iré yo; <br> y donde tú vivas, viviré."
      </p>
      <p class="cita-biblica">
        Rut 1:16
      </p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'PolaroidGallery',
  setup() {
    const imagenes = [
      new URL('@/assets/Karla y Jesús Preboda- 076 (1).webp', import.meta.url).href,
      new URL('@/assets/c12.png', import.meta.url).href,
    ]

    const currentImage = ref(imagenes[0])
    let index = 0

    const textoRef = ref(null)

    onMounted(() => {
      // Cambio de imagen automática
      setInterval(() => {
        index = (index + 1) % imagenes.length
        currentImage.value = imagenes[index]
      }, 2000)

      // Animación GSAP + Intersection
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          gsap.fromTo(
            textoRef.value,
            { opacity: 0, y: 60, rotateZ: -5 },
            {
              opacity: 1,
              y: 0,
              rotateZ: 0,
              duration: 1.6,
              ease: 'power4.out'
            }
          )
          observer.disconnect()
        }
      }, { threshold: 0.5 })

      if (textoRef.value) observer.observe(textoRef.value)
    })

    return { currentImage, textoRef }
  }
}
</script>

<style scoped>
.fondo-polaroid {
  width: 100vw;
  height: 80vh;
   background-color: #F4F1E9; ; 

  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.fondo-imagen {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(100%);
  z-index: 0;
}

.overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
}

.marco-polaroid {
  position: relative;
  width: 330px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);
  z-index: 2;
  text-align: center;
}
.foto-polaroid {
  width: 100%;
  display: block;
  border: none;
  object-fit: cover;
}

.contenedor-texto {
  z-index: 2;
  margin-top: 20px;
  max-width: 380px;
  width: 90%;
  padding: 10px 20px;
  transform-origin: bottom center;
}

.texto-invitacion {
  font-family: 'Corinthia', cursive;
  font-size: 40px;
  color: rgb(34, 34, 34);
  text-align: center;
  line-height: 1.2;
  margin: 0;
}

.cita-biblica {
  font-family: 'Playfair Display', serif;
  font-size: 14px;
  color: rgb(80, 80, 80);
  text-align: right;
  margin-top: 8px;
  margin-right: 10px;
  font-style: italic;
  letter-spacing: 1px;
}
</style>